import { ReactElement } from "react";
import { createRoot } from "react-dom/client";
import { InstanceOperatorMenuPageViewModel } from "client/Api/InstanceOperatorPage/instanceOperatorPage";
import { ensureNotNil } from "client/Misc/utils";
import { SupportInformation } from "../Support/SupportInformation";
import { ContentBlock } from "../PublicPage/ContentBlock";
import { Anchor } from "client/Components";
import styles from "./MenuPage.module.less";

export type MenuPageProps = {
	viewModel: InstanceOperatorMenuPageViewModel;
};

export const MenuPage = (props: MenuPageProps): ReactElement => {
	const {
		viewModel: {
			isMiniProfilerEnabled,
			permissions,
			supportInfo
		}
	} = props;

	return (
		<div className={styles.root}>
			<ContentBlock size="small">
				<h1>Choose your action</h1>

				<ul style={{ textAlign: "center", lineHeight: "24px" }}>
					{isMiniProfilerEnabled && (
						<li>
							<Anchor
								href="/mini-profiler-resources/results-index"
								target="_blank"

							>
								MiniProfiler
							</Anchor>
						</li>
					)}

					{permissions.canViewLogs && (
						<>
							<li>
								<Anchor href="/admin/Environments">
									Environments
								</Anchor>
							</li>

							<li>
								<Anchor href="/admin/ViewLogs">
									View log files
								</Anchor>
							</li>
						</>
					)}

					{permissions.canClearCache && (
						<li>
							<Anchor href="/admin/ClearSharedData">
								Clear shared data
							</Anchor>
						</li>
					)}

					{permissions.canDownloadUserReport && (
						<li>
							<Anchor href="/admin/DownloadUserReport">
								Download user report
							</Anchor>
						</li>
					)}

					<li>
						<Anchor href="/admin/SignOut">
							Sign out
						</Anchor>
					</li>
				</ul>
			</ContentBlock>

			<div className={styles.supportInfo}>
				<SupportInformation model={supportInfo} />
			</div>
		</div>
	);
};
MenuPage.displayName = "MenuPage";

export function init(viewModel: InstanceOperatorMenuPageViewModel): void {
	createRoot(
		ensureNotNil(
			document.getElementById("instance-operator-menu-page")
		)
	)
		.render(
			<MenuPage viewModel={viewModel} />
		);
}
